// Verification-evidence document checklists per scorecard element.
// Single source of truth for the consultant documentation pages and the client
// dashboard's "Upload documents" drawer. Keyed by backend element id.

const OWNERSHIP_DOCS = [
  'Organogram',
  'Shareholder Register',
  'Share Certificates',
  'Shareholder Agreements',
  'ID Copies of Shareholders / BEE Certificates',
  'Memorandum of Incorporation (MOI)',
  'Auditor Confirmation Letter',
];

const MANAGEMENT_CONTROL_DOCS = [
  'Staff Organogram',
  'EEA Reports',
  'Latest Valid Payroll',
  'Auditors Letter',
  'Headcount vs. EEA2 Discrepancy Letter',
  'Staff Management Comparison Letter',
  'ID Copies of Sampled Employees',
  'Employment Contracts of Sampled Employees',
  'Payslips of Sampled Employees',
  'EEA1 of Sampled Employees',
  'Doctors Note for Sampled Disabled Employees',
];

const SKILLS_DEVELOPMENT_DOCS = [
  'EMPSA',
  'EMP201',
  'WSP & ATR',
  'Proof of SETA Submission',
  'Approval of WSP & ATR/Letter stating no Approval has been received',
  'Scarce and Critical Skills Letter',
];

export const DOCUMENT_CHECKLISTS = {
  ownership: OWNERSHIP_DOCS,
  management_control: MANAGEMENT_CONTROL_DOCS,
  management_control_transport: MANAGEMENT_CONTROL_DOCS,
  employment_equity: MANAGEMENT_CONTROL_DOCS,
  skills_development: SKILLS_DEVELOPMENT_DOCS,
  skills_development_transport: SKILLS_DEVELOPMENT_DOCS,
  skills_development_specialised: SKILLS_DEVELOPMENT_DOCS,
};

// Elements without a defined checklist fall back to a single generic slot.
export const GENERIC_CHECKLIST = ['Supporting Documents'];

export const getChecklist = (elementId) =>
  DOCUMENT_CHECKLISTS[elementId] || GENERIC_CHECKLIST;
